let spotifyScript = document.createElement('script')
    spotifyScript.src = 'https://open.spotify.com/embed/iframe-api/v1'
    spotifyScript.async = true;
    spotifyScript.onload = () => {
        console.log('[Sapphire CMS] Spotify script loaded');
        window.onSpotifyIframeApiReady = (IFrameAPI) => {
            console.log('[Sapphire CMS] Spotify API Ready');
            console.log('[Sapphire CMS] Spotify players found', document.querySelectorAll('.spotify-content').length);
            document.querySelectorAll('.spotify-content')
                .forEach((embed, index) => {
                        console.log('[Sapphire CMS] Setup Spotify player #' + index);
                        let episode = embed.querySelector('.episode')
                        let element = embed.querySelector('.embed-iframe')
                        embed.querySelector('.button-content').classList.remove('d-none');
                        embed.querySelector('.loading-spinner').classList.add('d-none');

                        const options = {
                            uri: '',
                            width:"100%",
                            height:"232",
                            frameborder:"0",
                            allowtransparency:"true",
                            allow:"encrypted-media",
                            loading:"lazy",
                            display:'none'
                        };

                        IFrameAPI.createController(element, options, (EmbedController) => {
                            embed.querySelector('.button-content').addEventListener('click', async () => {

                                embed.querySelector('.button-content').classList.add('d-none');
                                embed.querySelector('.loading-spinner').classList.remove('d-none');

                                let fetchUrl = `${window.location.protocol}//${window.location.hostname}/api/spotify/get-episode-data/${episode.dataset.spotifyId}`;
                                const spotifyfetch = await fetch(fetchUrl, options);

                                embed.querySelector('.button-content').classList.remove('d-none');
                                embed.querySelector('.loading-spinner').classList.add('d-none');

                                if (spotifyfetch.status === 200) {
                                    embed.classList.add('active');
                                    embed.querySelector('.iframe-content').classList.remove('d-none');
                                    embed.querySelector('.button-content').classList.add('d-none');
                                    EmbedController.loadUri(`spotify:episode:${episode.dataset.spotifyId}`)
                                    EmbedController.play()
                                } else {
                                    embed.querySelector('.button-content').classList.add('d-none');
                                    embed.querySelector('.button-no-content').classList.remove('d-none');
                                }
                            });
                        });
                    }
                )
        }

    }


if(document.querySelectorAll('.spotify-content').length > 0) {
    document.body.appendChild(spotifyScript);
}

